import { useState, useRef } from 'react';
import { Loader2 } from 'lucide-react';
import { Header } from '@/components/Header';
import { useClientIp, useHostInfo } from './hooks/useIpEzBy';
import { ClientIpCard } from './components/ClientIpCard';
import { HostForm } from './components/HostForm';
import { ResultsSection } from './components/ResultsSection';

export function IpEzByPage() {
  const [showComments, setShowComments] = useState(false);
  const [host, setHost] = useState('');
  const formRef = useRef<HTMLDivElement>(null);

  const { data: clientIpData, isLoading: isLoadingClientIp } = useClientIp();
  const hostInfoMutation = useHostInfo();

  // Обработчик клика по IP/домену в результатах
  const handleHostClick = (clickedHost: string) => {
    setHost(clickedHost);
    // Скролл к форме
    formRef.current?.scrollIntoView({ behavior: 'smooth' });
    // Автоматически запускаем поиск
    hostInfoMutation.mutate(clickedHost);
  };

  const handleSubmit = (submittedHost: string) => {
    hostInfoMutation.mutate(submittedHost);
  };

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Header title="ip.ez.by" showBack />

      <main className="flex-1 p-4 space-y-4 overflow-y-auto pb-20">
        {/* Client IP Card */}
        <ClientIpCard
          ip={clientIpData?.ip}
          provider={clientIpData?.provider}
          isLoading={isLoadingClientIp}
          onIpClick={handleHostClick}
        />

        {/* Host Form */}
        <div ref={formRef}>
          <HostForm
            host={host}
            onHostChange={setHost}
            onSubmit={handleSubmit}
            isLoading={hostInfoMutation.isPending}
            showComments={showComments}
            onShowCommentsChange={setShowComments}
          />
        </div>

        {/* Loading */}
        {hostInfoMutation.isPending && (
          <div className="flex items-center justify-center py-8">
            <Loader2 className="w-8 h-8 animate-spin text-primary" />
          </div>
        )}

        {/* Results */}
        <ResultsSection
          data={hostInfoMutation.data || null}
          showComments={showComments}
          onHostClick={handleHostClick}
        />
      </main>
    </div>
  );
}
